module.exports = __webpack_public_path__ + "img/origin.2be0de6d.svg";